<div
  class="host h-15 md:h-13"
  (contextmenu)="onContextMenu($event, program)"
  [ngClass]="{
    'context-menu-open': hasContextMenuOpen
  }"
  [style.margin-left.px]="$xAxis()"
>
  <div class="name min-w-0">
    <div
      class="color h-15 md:h-2.5 ml-0 mr-4 md:ml-2.5 aspect-square rounded-l md:rounded-sm"
      [style.background]="program.color"
    ></div>
    <div class="flex flex-col min-w-0">
      <div
        class="text-ellipsis whitespace-nowrap overflow-hidden mr-2 font-bold md:font-semibold"
      >
        {{ program.name }}
      </div>
      <div class="block md:hidden text-gray-darkest">
        {{
          'SCHEDULE.PROGRAMS.PLAYLISTS_NUMBER'
            | translate: { count: program.playlistsNumber }
        }}
      </div>
    </div>
  </div>
  <div class="playlist hidden md:block flex-1">
    <mat-icon fontSet="fa" fontIcon="fa-indent"></mat-icon>
    {{ program.playlistsNumber }}
  </div>
  <div class="estimation flex-initial md:flex-1 pr-2 md:mr-0 text-right md:text-left">
    <div class="hidden md:inline-block">
      <mat-icon fontSet="fa" fontIcon="fa-clock"></mat-icon>
    </div>
    {{
      program.estimatedDuration ? (program.estimatedDuration | bigTimeFormatLetters) : '-'
    }}
  </div>
  <rk-icon-button
    [bordered]="true"
    [svgIcon]="'dot-down'"
    class="mr-4 absolute hidden"
    [size]="23"
    [style]="{ width: '29px', height: '29px' }"
    (click)="onContextMenu($event, program)"
  >
  </rk-icon-button>
  <div
    class="md:hidden mob-actions w-15 h-15 flex justify-center items-center overflow-hidden ml-3 rounded-r"
    [style.margin-right.px]="-$xAxis() - iconSize"
  >
    <div
      class="bg-error w-15 h-15 flex justify-center items-center overflow-hidden"
      (click)="deleteProgram($event, program)"
    >
      <mat-icon fontSet="far" fontIcon="fa-trash-alt" class="text-white"></mat-icon>
    </div>
  </div>
</div>
